/**
 * Cart Empty State - Clean, encouraging empty state
 * Follows design guidelines: minimal illustration, warm colors
 */
import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function CartEmptyState({ onClose }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center" data-testid="cart-empty-state">
      <div className="w-20 h-20 rounded-2xl bg-muted/50 flex items-center justify-center mb-4">
        <ShoppingCart className="w-10 h-10 text-muted-foreground opacity-40" strokeWidth={1.5} />
      </div>
      <h3 className="text-lg font-semibold heading-font mb-2">Your cart is empty</h3>
      <p className="text-sm text-muted-foreground max-w-xs mb-6">
        Start adding rooms and meeting spaces to create your perfect booking.
      </p>
      <Button
        variant="outline"
        onClick={onClose}
        data-testid="cart-empty-close-button"
      >
        Continue Browsing
      </Button>
    </div>
  );
}
